module.exports = __webpack_public_path__ + "media/images/fbcalls/bg_intro-e44feaf08d5892ae9e710f4da84c33aa.png";